const class2type = {};

export default function toType(obj) {
	if(obj == null) {
		return obj + "";
	}

	return typeof obj === "object" ?
		class2type[toString.call(obj)] || "object" :
		typeof obj;
}